/** Strips Markdown syntax (headings, bold, italic, list markers) down to plain readable text.
 * Used for short previews/excerpts (card teasers, SEO meta description) where full Markdown
 * rendering isn't appropriate. */
export function stripMarkdown(text = "") {
  return text
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/\*(.*?)\*/g, "$1")
    .replace(/^[-*]\s+/gm, "")
    .replace(/^\d+\.\s+/gm, "")
    .replace(/\n{2,}/g, " ")
    .replace(/\n/g, " ")
    .trim();
}
